var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.isLoggedIn)?_c('not-logged-landing-page'):_vm._e(),(_vm.isLoggedInAsAssistant)?_c('assistant-landing-page'):_vm._e(),(_vm.isLoggedInAsClient)?_c('client-landing-page'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }